import {
  put,
  all,
  takeLatest,
} from 'redux-saga/effects';
import * as types from './types';
import * as baseTypes from './base/types';
import * as filterDataTypes from './filtersData/types';
import * as trendsDataTypes from './trendsData/types';
import * as drawersDataTypes from './drawer/types';

import { sagas as baseSagas } from './base';
import { sagas as filtersDataSagas } from './filtersData';
import { sagas as tendsDataSagas } from './trendsData';
import { sagas as thresholdSagas } from './threshold';
import { sagas as sharingSagas } from './sharing';
import { sagas as dashboardSagas } from './dashboard';
import { sagas as tempDashboard } from './tempDashboard';
import { sagas as drawerSagas } from './drawer';


function* init() {
  yield all([
    put({ type: baseTypes.INIT }),
    put({ type: filterDataTypes.INIT }),
    put({ type: trendsDataTypes.INIT }),
    put({ type: drawersDataTypes.INIT }),
  ]);
}

function* reset() {
  yield init();
}

function* watchReset() {
  yield takeLatest(types.RESET, reset);
}

export default [
  init,
  watchReset,
  ...baseSagas,
  ...filtersDataSagas,
  ...tendsDataSagas,
  ...thresholdSagas,
  ...sharingSagas,
  ...dashboardSagas,
  ...tempDashboard,
  ...drawerSagas,
];
